import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Redirect = ({ link, stato }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(link, { state: stato });
    }, [navigate, link, stato]);
};